import { atom } from 'recoil'
import { Person } from '../types/Person'

export const PeopleAtom = atom<Person[]>({
  key: 'person-atom',
  default: [],
})
